import { render } from "./PortalHeader.vue?vue&type=template&id=115ef924&scoped=true"
import script from "./PortalHeader.vue?vue&type=script&lang=js"
export * from "./PortalHeader.vue?vue&type=script&lang=js"

import "./PortalHeader.vue?vue&type=style&index=0&id=115ef924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115ef924"]])

export default __exports__